import { HeaderBase } from "../../shared/HeaderBase";
import logo from "../images/logo-nutripur-2.svg";

export const Header = () => (
  <HeaderBase brand={<img src={logo} alt="Nutripur" style={{ height: 60 }} />} />
);
